import isUndefined from "lodash.isundefined";
import { DEFAULT_FOLDER_ID, virtualFolderIds } from "../constants";

// Get all the virtual folder IDs that aren't "My Zaps Default Folder"
export const foldersToFilter = virtualFolderIds.filter(
  (folderId: string | undefined) => folderId !== DEFAULT_FOLDER_ID,
);

const isVirtualFolderNotDefault = (folderId: string | undefined) => {
  if (isUndefined(folderId)) {
    return false;
  }
  return foldersToFilter.includes(folderId);
};

export default isVirtualFolderNotDefault;
